// The shop API (same origin: the Istio VirtualService routes /api/* to the backend; `npm start` proxies it).
async function call(method, path, body, { headers = {}, signal } = {}) {
  const res = await fetch(path, {
    method,
    headers: { ...(body ? { 'Content-Type': 'application/json' } : {}), ...headers },
    body: body ? JSON.stringify(body) : undefined,
    signal,
  });
  let data = null;
  try {
    data = await res.json();
  } catch {
    /* not JSON (e.g. a proxy error page) */
  }
  if (!res.ok || !data || data.success === false) {
    const err = new Error((data && data.message) || `The shop is not answering (HTTP ${res.status})`);
    err.status = res.status;
    err.code = data && data.error;
    err.details = data && data.details;
    throw err;
  }
  return data.data;
}

export const listMacarons = (params, signal) => {
  const qs = new URLSearchParams(Object.entries(params).filter(([, v]) => v !== '' && v !== false && v != null));
  return call('GET', `/api/macarons${qs.toString() ? `?${qs}` : ''}`, undefined, { signal });
};
export const listFlavors = () => call('GET', '/api/flavors');
export const getPricing = () => call('GET', '/api/pricing');
// idempotencyKey: one UUID per checkout, reused on retries, so a retry after a lost response cannot order twice.
export const placeOrder = (order, idempotencyKey) => call('POST', '/api/orders', order, { headers: { 'Idempotency-Key': idempotencyKey } });
export const getOrder = (id) => call('GET', `/api/orders/${encodeURIComponent(id)}`);
export const cancelOrder = (id) => call('POST', `/api/orders/${encodeURIComponent(id)}/cancel`);
